const CLOUDINARY_HOST_PATTERN = /^(https?:)?\/\/res\.cloudinary\.com/i;
const PROXY_HOST = "https://img.komercia.store";

function normalizePath(path) {
  if (path == null) {
    return "";
  }

  if (typeof path !== "string") {
    return path;
  }

  if (!path.includes("res.cloudinary.com")) {
    return path;
  }

  return path.replace(CLOUDINARY_HOST_PATTERN, PROXY_HOST);
}

export function getImageUrl(path) {
  return normalizePath(path);
}

export function getImageUrls(paths) {
  if (!Array.isArray(paths)) {
    return normalizePath(paths);
  }

  return paths.map((item) => normalizePath(item));
}

export function replaceImageUrlsInPlace(value) {
  if (value == null) {
    return value;
  }

  if (typeof value === "string") {
    return getImageUrl(value);
  }

  if (Array.isArray(value)) {
    for (let i = 0; i < value.length; i += 1) {
      value[i] = replaceImageUrlsInPlace(value[i]);
    }
    return value;
  }

  if (typeof value === "object") {
    const constructorName = value.constructor && value.constructor.name;
    if (constructorName && constructorName !== "Object") {
      return value;
    }

    Object.keys(value).forEach((key) => {
      value[key] = replaceImageUrlsInPlace(value[key]);
    });
    return value;
  }

  return value;
}

export function normalizeImageData(value) {
  if (value == null) {
    return value;
  }

  if (typeof value === "string") {
    return getImageUrl(value);
  }

  if (Array.isArray(value)) {
    return value.map((item) => normalizeImageData(item));
  }

  if (typeof value === "object") {
    const output = {};
    Object.keys(value).forEach((key) => {
      output[key] = normalizeImageData(value[key]);
    });
    return output;
  }

  return value;
}

export default getImageUrl;
